import type { Dispatch } from "react";
import { InputList } from "../../../components/Input/InputList";
import type { HandleOnBlurProps } from "./types";

interface CreateRefinanceInputListProps {
  setNewRefinancingDetails: React.Dispatch<React.SetStateAction<any>>;
  setErrorMessages: React.Dispatch<React.SetStateAction<string>>;
  newRefinancingDetails: any;
  updateAmountSum: (newAmountSum: number) => void;
  inputOrder: number;
  handleOnBlur: (props: HandleOnBlurProps) => void;
  handleDelete: (idToDelete: string | undefined) => void;

}
export const createRefinanceInputList = ({ updateAmountSum, handleDelete, handleOnBlur, inputOrder, newRefinancingDetails, setErrorMessages, setNewRefinancingDetails }: CreateRefinanceInputListProps) => {
  const refinanceInputs = []
  let newAmountSum = 0;
  for (const [, details] of (newRefinancingDetails ?? []).entries()) {
    const { id, order, ...visibleDetails } = details;
    const newDetails: any = visibleDetails;
    if (Number.isNaN(newDetails.amount)) {
      newDetails.amount = "";
    }
    if (typeof newDetails.amount === "string") {
      newAmountSum += newDetails.amount === "" ? 0 : Number.parseFloat(newDetails.amount);
    }
    else {
      newAmountSum += newDetails.amount;
    }

    newDetails.type = {
      defaultValue: newDetails.type,
      options: [
        { label: "Loan", value: "loan" },
        { label: "Card", value: "card" },
      ]
    };

    newDetails.isFromUc = {
      defaultValue: typeof newDetails.isFromUc === "boolean" ? newDetails.isFromUc ? "true" : "false" : typeof newDetails.isFromUc === "string" ? newDetails.isFromUc : "false",
      options: [
        { label: "Yes", value: "true" },
        { label: "No", value: "false" },
      ],
    }

    const input = (
      <InputList
        deletable={true}
        onClick={() => handleDelete(id)}
        title={"Refinance details"}
        infoLists={[
          {
            title: "",
            context: visibleDetails,
            onBlur: (key, e) =>
              handleOnBlur({ key, e, id, setErrorMessages, setNewRefinancingDetails }),
            id: id,
          },
        ]}
      />
    );
    updateAmountSum(newAmountSum);

    refinanceInputs.push({ component: input, order: inputOrder });
  }
  return refinanceInputs;
}